import React from "react";
import {Container, Navbar, Nav, Button} from "react-bootstrap";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Link,
} from "react-router-dom";
import {HashLink} from "react-router-hash-link";
import Home from "./Home";
import Actualites from "./Actualites";
import MentionLegale from "./MentionLegale";
import {DONATION_URL} from "./constants";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

function App() {
  return (
    <Router>
      <div className="App">
        <a href="#main-content" className="skip-link">
          Aller au contenu
        </a>
        <Navbar
          expand="lg"
          fixed="top"
          className="site-navbar"
          collapseOnSelect
        >
          <Container>
            <Navbar.Brand as={Link} to="/" className="brand">
              <span className="brand-mark">ASTS</span>
              <span className="brand-text">Temple de Sommières</span>
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="main-nav" />
            <Navbar.Collapse id="main-nav" className="justify-content-end">
              <Nav>
                <Nav.Link as={HashLink} smooth to="/#Lassociation">
                  Association
                </Nav.Link>
                <Nav.Link as={HashLink} smooth to="/#Histoire">
                  Histoire
                </Nav.Link>
                <Nav.Link as={HashLink} smooth to="/#CommentSoutenir">
                  Soutenir
                </Nav.Link>
                <Nav.Link as={Link} to="/actualites">
                  Actualités
                </Nav.Link>
                <Nav.Link as={HashLink} smooth to="/#Contact">
                  Contact
                </Nav.Link>
              </Nav>
              <Button
                as="a"
                href={DONATION_URL}
                target="_blank"
                rel="noopener noreferrer"
                variant="primary"
                className="navbar-donate-cta"
              >
                Faire un don
              </Button>
            </Navbar.Collapse>
          </Container>
        </Navbar>

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/actualites" element={<Actualites />} />
          <Route path="/mentions-legales" element={<MentionLegale />} />
          <Route
            path="/mention-legale"
            element={<Navigate to="/mentions-legales" replace />}
          />
        </Routes>

        <Footer />
      </div>
    </Router>
  );
}

function Footer() {
  return (
    <footer className="site-footer">
      <Container>
        <div className="footer-grid">
          <div className="footer-col">
            <p className="footer-heading">Contact</p>
            <p className="footer-line">
              <a href="mailto:astsommieres@gmail.com">
                astsommieres@gmail.com
              </a>
            </p>
            <p className="footer-line footer-muted">
              16 route de Montpellier, 30250 Sommières
            </p>
          </div>
          <div className="footer-col">
            <p className="footer-heading">Liens</p>
            <Link to="/actualites" className="footer-link">
              Actualités
            </Link>
            <a
              href={DONATION_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
            >
              Faire un don
            </a>
            <Link to="/mentions-legales" className="footer-link">
              Mentions légales
            </Link>
          </div>
        </div>
        <p className="footer-copy">
          © {new Date().getFullYear()} Association de Sauvegarde du Temple de
          Sommières
        </p>
      </Container>
    </footer>
  );
}

export default App;
